"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = exports.Label = exports.IconContainer = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Utils = require("../Utils");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const Container = exports.Container = (0, _styledComponents.default)(_Utils.Button).withConfig({
  shouldForwardProp: prop => !['contrast'].includes(prop)
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    align-items: center;\n    ", ";\n    cursor: pointer;\n    display: flex;\n    flex-direction: row;\n    ", "\n    ", "\n    width: fit-content;\n\n    ", "\n"])), _ref => {
  let {
    color,
    theme: {
      textColor
    }
  } = _ref;
  return "color: ".concat(color !== null && color !== void 0 ? color : textColor);
}, (0, _Utils.parseProp)('margin'), (0, _Utils.parseProp)('padding'), _ref2 => {
  let {
    contrast,
    theme: {
      overPrimaryColor
    }
  } = _ref2;
  return !contrast ? '' : "\n        :focus {\n            box-shadow: 0px 0px 1px 1px ".concat(overPrimaryColor, ";\n        }\n    ");
});
const IconContainer = exports.IconContainer = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n    position: relative;\n"])), (0, _Utils.parseProp)('margin'));
const Label = exports.Label = _styledComponents.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n    text-decoration: underline;\n"])), (0, _Utils.parseProp)('fontSize', 'font-size'));
const Notification = exports.Notification = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-radius: 5px;\n    color: #FFF;\n    font-size: 11px;\n    padding: 1px 4px;\n    position: absolute;\n    right: -7px;\n    top: -5px;\n"])), (0, _Utils.getTheme)('dangerColor'));